import { IButtonStyles, IconButton, IIconProps } from '@fluentui/react';
import React from 'react';

const styleButton: IButtonStyles = {
  root: {
    color: 'black',
    border: 'none',
    background: 'none'
  },
  rootHovered: {
    background: 'none'
  }
};

const expandIcon: IIconProps = {
  iconName: 'ChevronDown'
};

const collapseIcon: IIconProps = {
  iconName: 'ChevronRight'
};

interface CollapseToggleIconProps {
  isCollapsed: boolean;
  onClick(): void;
}

export const CollapseToggleIcon: React.FunctionComponent<CollapseToggleIconProps> = props => {
  const iconProps = props.isCollapsed ? expandIcon : collapseIcon;

  return <IconButton styles={styleButton} onClick={(): void => props.onClick()} iconProps={iconProps} />;
};
